module.exports = __webpack_public_path__ + "img/NoWeb@2x.365640ef.png";